import CircularProgress from '@mui/material/CircularProgress';
import { memo } from 'react';

const Loading = () => (
  <div
    style={{
      height: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      zIndex: '1000',
    }}
  >
    <CircularProgress />
  </div>
);

export default memo(Loading);
